import { LinkButton } from "@/ui/next/LinkButton";
import Link from "@whoppah/next/link";
import { useTranslation } from "next-i18next";

import SparkIcon from "@/assets/icons/24/Spark";
import { Support } from "@/assets/icons/24/Support";
import { FacebookFilled as FacebookIcon } from "@/assets/icons/24/social/FacebookFilled";
import InstagramIcon from "@/assets/icons/24/social/Instagram";
import LinkedInIcon from "@/assets/icons/24/social/LinkedIn";
import { TikTok } from "@/assets/icons/24/social/TikTok";
import { WhoppahFullSize } from "@/assets/icons/Logo";
import { analyticsService } from "@/common/services/analytics/analytics.service";
import {
  FACEBOOK_URL,
  INSTAGRAM_URL,
  LINKEDIN_URL,
  TIKTOK_URL,
} from "@/common/static/footer.static";
import { HELP_ROUTE } from "@/common/static/routes.static";
import { Body } from "@/ui/typography/Body";

const LINKS = [
  {
    url: FACEBOOK_URL,
    icon: FacebookIcon,
    label: "Go to Whoppah Facebook page",
    platform: "facebook",
  },
  {
    url: INSTAGRAM_URL,
    icon: InstagramIcon,
    label: "Go to Whoppah Instagram page",
    platform: "instagram",
  },
  {
    url: TIKTOK_URL,
    icon: TikTok,
    label: "Go to Whoppah TikTok page",
    platform: "tiktok",
  },
  {
    url: LINKEDIN_URL,
    icon: LinkedInIcon,
    label: "Go to Whoppah LinkedIn page",
    platform: "linkedin",
  },
];

export const FooterWhoppahInfo = () => {
  const { t } = useTranslation();

  const handleSocialButtonClick = (platform: string) => () => {
    /** Trigger `hp_social_media_links` event. */
    analyticsService.trackHpSocialMediaLinks(platform);
  };

  return (
    <div className="flex flex-col space-y-4 text-[#585858]">
      <Link
        href="/"
        aria-label="Go to Whoppah Homepage"
        className="focus:rounded-[0.25rem] focus:outline-none focus-visible:ring-2 focus-visible:ring-curious-200 focus-visible:ring-offset-4 focus-visible:ring-offset-[#F0F5F0]"
      >
        <WhoppahFullSize className="hidden w-[150px] text-brand-500  md:block" />
        <SparkIcon className="-mb-3 block h-8 w-8 text-brand-500 md:hidden" />
      </Link>
      <Body as="p">{t("common:support-work-time")}</Body>
      <LinkButton
        size="large"
        appearance="outlined"
        rightIcon={<Support />}
        href={HELP_ROUTE}
        className="self-start rounded-full"
      >
        {t("common:visit-support-center")}
      </LinkButton>
      <span className="flex gap-x-5">
        {LINKS.map(link => (
          <Link
            key={link.url}
            href={link.url}
            aria-label={link.label}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="focus:rounded-[0.25rem] focus:outline-none focus-visible:ring-2 focus-visible:ring-curious-200 focus-visible:ring-offset-4 focus-visible:ring-offset-[#F0F5F0]"
            onClick={handleSocialButtonClick(link.platform)}
          >
            <link.icon className="h-6 w-6 text-brand-500" />
          </Link>
        ))}
      </span>
    </div>
  );
};
